/* unplugin-vue-components disabled */import script from "./salesman-modal.vue?vue&type=script&setup=true&lang=js"
export * from "./salesman-modal.vue?vue&type=script&setup=true&lang=js"

import "./salesman-modal.vue?vue&type=style&index=0&id=2b933d5e&lang=scss"

const __exports__ = script;

export default __exports__